<template>
  <div class="shopServe-root">
    <div>
      <!-- <Steps :active="active" active-color="#38f">
        <Step>选择服务</Step>
        <Step>确认下单</Step>
        <Step>到店服务</Step>
      </Steps> -->
      <div class="content">
        <div class="serve" v-if="active === 0">
          <div class="form-wrap">
            <Form @submit="onSubmit">
              <Card title="车型与服务">
                <Field
                  name="car_model"
                  v-model="carModal"
                  label="车型"
                  placeholder="请输入车型"
                />
                <Collapse v-model="activeName" accordion>
                  <CollapseItem title="选择服务类型" name="1">
                    <Field name="service_info">
                      <template #input>
                        <div style="width:100%">
                          <CheckboxGroup v-model="result">
                            <cellGroup :border="false">
                              <Cell
                                v-for="(item, index) in list"
                                clickable
                                :key="item"
                                :title="`${item}`"
                                @click="toggle(index)"
                              >
                              <template #right-icon>
                                <Checkbox :name="item" ref="checkboxes" />
                              </template>
                              </Cell>
                            </cellGroup>
                          </CheckboxGroup>
                        </div>
                      </template>
                    </Field>
                  </CollapseItem>
                </Collapse>
              </Card>
              <Card title="预约时间">
                <Field
                  readonly
                  clickable
                  name="calendar"
                  :value="dateValue"
                  label="日期选择"
                  placeholder="点击选择日期"
                  :rules="[{ required: true, message: '请选择日期' }]"
                  @click="showCalendar = true"
                />
                <Field
                  readonly
                  clickable
                  name="datetimePicker"
                  :value="timeValue"
                  label="时间选择"
                  placeholder="点击选择时间"
                  :rules="[{ required: true, message: '请选择时间' }]"
                  @click="showPicker = true"
                />
                <Popup v-model="showPicker" position="bottom">
                  <DatetimePicker
                    type="time"
                    :filter="filter"
                    @confirm="onConfirmTime"
                    @cancel="showPicker = false"
                  />
                </Popup>
              </Card>
              <Card title="选择门店">
                <Collapse v-model="activeStore" accordion>
                  <CollapseItem title="门店选择" name="1">
                    <Field name="related_store">
                      <template #input>
                        <div style="width:100%">
                          <RadioGroup v-model="packageRadio">
                            <CellGroup :border="false">
                              <Cell v-for="item in packageList" :key="item.id" :title="item.name" clickable @click="packageRadio = item.id">
                                <Radio slot="right-icon" :name="item.id" />
                                <div slot="label">
                                  <div>{{item.address}}</div>
                                  <div>{{item.contact}}</div>
                                </div>
                              </Cell>
                            </CellGroup>
                          </RadioGroup>
                        </div>
                      </template>
                    </Field>
                  </CollapseItem>
                </Collapse>
              </Card>
              <Card title="客户信息">
                <Field
                  v-model="name"
                  name="name"
                  label="姓名"
                  placeholder="请输入姓名"
                  :rules="[{ required: true, message: '请填写姓名' }]"
                />
                <Field
                  v-model="phoneNUmber"
                  name="mobile"
                  label="手机号"
                  type="tel"
                  placeholder="请输入手机号"
                  :rules="[{ required: true, message: '请填写联系方式' }]"
                />
                <Field
                  v-model="carNumer"
                  name="car_number"
                  label="车牌号"
                  placeholder="请输入车牌号"
                  :rules="[{ required: true, message: '请填写居住地' }]"
                />
              </Card>
              <Card title="备注">
                <Field
                  v-model="message"
                  rows="2"
                  autosize
                  name="notes"
                  type="textarea"
                  maxlength="50"
                  placeholder="请补您的维修需求"
                  show-word-limit
                />
              </Card>
              <div style="margin: 16px;">
                <Button round block type="info" native-type="submit">
                  提交
                </Button>
              </div>
            </Form>
          </div>
          <Calendar v-model="showCalendar" color='linear-gradient(to right, #4bb0ff, #6149f6)' @confirm="onConfirm" />
        </div>
        <div class="price" v-if="active === 1">门店报价</div>
      </div>
    </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import Card from '@/components/Card'
export default {
  data() {
    return{
      active:0,
      activeName:'1',
      activeStore:'1',
      showCalendar:false,
      showPicker:false,
      carModal:"",
      name:"",
      phoneNUmber:"",
      carNumer:'',
      message:'',
      dateValue:'',
      timeValue:"",
      radio:'',
      packageRadio:'',
      oilList:[],
      packageList:[],
      checkboxGroup:[],
      list: ['常规维修', '钣金喷漆', '空调清洗', '汽车美容', '其他'],
      result: []
    }
  },
  components:{
    Card
  },
  created() {
    document.title = '到店服务'
    this.queryPackageList()
  },
  watch:{
    $route(value) {
      let { meta:{name} } = value
      document.title = name
    }
  },
  methods:{
    async queryPackageList() {
      const res = await http({
        url:api.storeInfo
      })
      if(res) {
        console.log(res)
        this.packageList = res
      }
    },
    async postHandle(data) {
      const res = await http({
        url:api.servePost,
        method:'POST',
        data:{
          ...data,
          reserve_type:2
        }
      })
      if(res) {
        this.$router.push('/success')
      }
      console.log(res)
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    filter(type, options) {
      if (type === 'hour') {
        return options.filter(option => {
          if( parseInt(option) > 7 && parseInt(option) < 20) {
            return option
          }
        });
      }
      if (type === 'minute') {
        return options.filter(option => option % 30 === 0);
      }
      return options;
    },
    onSubmit(values) {
      // this.active = 1
      let reserve_time = `${values.calendar} ${values.datetimePicker}`
      delete values['calendar']
      delete values['datetimePicker']
      let option = {
        ... values,
        reserve_time,
        service_info:values.service_info.join(',')
      }
      this.postHandle(option)
      console.log('submit', option);
    },
    onConfirm(date) {
      this.dateValue = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showCalendar = false;
    },
    onConfirmTime(time) {
      this.timeValue = time;
      this.showPicker = false;
    },
  }
}
</script>

<style lang="less">
.shopServe-root{
  width: 100%;
  height: 100%;
  overflow: auto;
  .padding{
    height: 20px;
  }
  .content{
    padding: 20px 12px;
    .serve{
      .form-wrap{
        border-radius: 10px;
      }
    }
  }
  .van-cell__title {
    text-align: left;
  }
  .van-collapse-item__content{
    padding: 0;
  }
  .van-checkbox--horizontal {
    margin-bottom: 6px;
  }
}
</style>